/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    volume: PropTypes.number,
    className: PropTypes.string,
};

const SoundIcon = ({ color = '#FFF', volume = 1, className = null }) => (
    <svg
        width="50px"
        height="50px"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        {volume === 0 ? (
            <>
                <polygon
                    fill={color}
                    points="30.01 15.75 30.01 9.95 19.97 19.98 12.95 19.98 12.95 30.02 15.74 30.02 30.01 15.75"
                />
                <polygon fill={color} points="30.01 40.05 30.01 24.24 22.1 32.14 30.01 40.05" />
                <path
                    fill={color}
                    d="M35.14,19.1l-1.14,1.14c1.38,1.17,2.22,2.91,2.22,4.76,0,2.39-1.4,4.6-3.56,5.62l.69,1.45c2.72-1.29,4.47-4.07,4.47-7.07,0-2.28-1.01-4.43-2.69-5.9Z"
                />
                <path
                    fill={color}
                    d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0ZM4,25C4,13.42,13.42,4,25,4c5.13,0,9.84,1.85,13.49,4.92l-29.57,29.57c-3.07-3.65-4.92-8.36-4.92-13.49ZM25,46c-5.13,0-9.84-1.85-13.49-4.92l29.57-29.57c3.07,3.65,4.92,8.36,4.92,13.49,0,11.58-9.42,21-21,21Z"
                />
            </>
        ) : (
            <>
                <polygon
                    fill={color}
                    points="12.95 19.98 12.95 30.02 19.97 30.02 30.01 40.05 30.01 9.95 19.97 19.98 12.95 19.98"
                />
                {volume === 1 ? (
                    <path
                        fill={color}
                        d="M33.36,17.93l-.69,1.45c2.16,1.03,3.56,3.23,3.56,5.62s-1.4,4.6-3.56,5.62l.69,1.45c2.72-1.29,4.47-4.07,4.47-7.07s-1.76-5.78-4.47-7.07Z"
                    />
                ) : null}
                <path
                    fill={color}
                    d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0ZM25,46c-11.58,0-21-9.42-21-21S13.42,4,25,4s21,9.42,21,21-9.42,21-21,21Z"
                />
            </>
        )}
    </svg>
);

SoundIcon.propTypes = propTypes;

export default SoundIcon;
